import React, {memo,useState} from "react";
import Styles from "./dataAnalysis.module.scss";
import {showDuration} from "../../../../util/util";
const GeneralData = ({data,item}) => {
    const [select , setSelect ] = useState('min/max')
    return(
        <div className={`${Styles.generalData} w-100 mt-3 d-flex flex-column justify-content-between`}>
            <div className="d-flex justify-content-between">
                <p className="dark-gary-2 f16 fw500">General Data</p>
                <div className="d-flex">
                    <button onClick={() => setSelect('min/max')} className={`ellipse  ${select === 'min/max' && 'ellipse-active'}`}>
                        Min/Max
                    </button>
                    <button  onClick={() => setSelect('mean')} className={`ellipse  ${select === 'mean' && 'ellipse-active'} mx-2`}>
                       Mean
                    </button>
                    <button  onClick={() => setSelect('std')} className={`ellipse  ${select === 'std' && 'ellipse-active'}`}>
                        Std. Dev.
                    </button>
                </div>
            </div>
            <div className="d-flex justify-content-between">
                <div>
                    <p className="dark-gary-2 f13 fw300">{item.toLowerCase().includes('case') ? 'Case Count' : 'Activities'}</p>
                    <p className="dark-gary-2 f14 fw700">{item.toLowerCase().includes('case') ?  data?.case_count : data?.activities}</p>
                </div>
                {/*<div>*/}
                {/*    <p className="dark-gary-2 f13 fw300">Connections</p>*/}
                {/*    <p className="dark-gary-2 f14 fw700">{383}</p>*/}
                {/*</div>*/}


                {item.toLowerCase().includes('case') ?
                    <div>
                        <p className="dark-gary-2 f13 fw300">Activities Count</p>
                        <p className="dark-gary-2 f14 fw300">
                            {select === 'min/max' ?
                                <>
                                    <span className="fw700 f14">{data?.activity_count?.min}</span> (Min) | <span className="fw700 f14">{data?.activity_count?.max}</span> (Max)
                                </>
                                :
                                <span className="fw700 f14">{select === 'std' ? data?.activity_count?.std : data?.activity_count?.median}</span>
                            }
                        </p>
                    </div>
                    :
                    <div>
                        <p className="dark-gary-2 f13 fw300">Case Frequency</p>
                        <p className="dark-gary-2 f14 fw300">
                            {select === 'min/max' ?
                                <>
                                    <span className="fw700 f14">{data?.case_frequency?.min}</span> (Min) | <span className="fw700 f14">{data?.case_frequency?.max}</span> (Max)
                                </>
                                :
                                <span className="fw700 f14">{select === 'std' ? data?.case_frequency?.std : data?.case_frequency?.median}</span>
                            }
                        </p>
                    </div>
                }
                {item.toLowerCase().includes('case') ?
                    <div>
                        <p className="dark-gary-2 f13 fw300">Throughput Time</p>
                        {select === 'min/max' ?
                            <>
                                <span className="fw700 f14">{showDuration(data?.throughput_time?.min)}</span> (Min) | <span className="fw700 f14">{showDuration(data?.throughput_time?.max)}</span> (Max)
                            </>
                            :
                            <span className="fw700 f14">{showDuration(select === 'std' ? data?.throughput_time?.std : data?.throughput_time?.median)}</span>
                        }
                    </div>
                    :
                    <div>
                        <p className="dark-gary-2 f13 fw300">Activity Total Duration</p>
                        <p className="dark-gary-2 f14 fw300">
                            {select === 'min/max' ?
                                <>
                                    <span className="fw700 f14">{showDuration(data?.activity_total_duration?.min)}</span> (Min) | <span className="fw700 f14">{showDuration(data?.activity_total_duration?.max)}</span> (Max)
                                </>
                                :
                                <span className="fw700 f14">{showDuration(select === 'std' ? data?.activity_total_duration?.std : data?.activity_total_duration?.median)}</span>
                            }
                        </p>
                    </div>
                }
                <div>
                    <p className="dark-gary-2 f13 fw300">Rework Count</p>
                    {select === 'min/max' ?
                      <p className="dark-gary-2 f14 fw300"><span className="fw700">{data?.rework?.min}</span> (Min) | <span className="fw700">{data?.rework?.max}</span> (Max)</p>
                      :
                      <span className="fw700 f14">{select === 'std' ? data?.rework?.std :  data?.rework?.median}</span>
                    }
                </div>
            </div>
        </div>
    )
}
export default memo(GeneralData);
